import { Component } from '@angular/core';
import { CcdlLinkComponent } from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'cui-privacy-policy',
  imports: [CcdlLinkComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {}
